export const TAB_HIT_PADDING_X = 8;

export const INDICATOR_BASE_WIDTH = 200;

export type IndicatorRect = { left: number; width: number };

export const formatTransform = (rect: IndicatorRect) =>
  `translate3d(${rect.left}px, 0, 0) scaleX(${rect.width / INDICATOR_BASE_WIDTH})`;

/** Underlines the label text only, not the tab's full hit area. */
export const measureLabelRect = (tab: HTMLAnchorElement): IndicatorRect => {
  const padX =
    parseFloat(getComputedStyle(tab).paddingLeft) || TAB_HIT_PADDING_X;
  return {
    left: tab.offsetLeft + padX,
    width: tab.offsetWidth - padX * 2,
  };
};
